import { type ReduxStateShared } from '~shared/types';

const getSelectedPaymentTypes = (state: ReduxStateShared) => state.cart.cart.selected_payment_types;

export default getSelectedPaymentTypes;
